import { render } from "./AddUser.vue?vue&type=template&id=500f4e94&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=500f4e94&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500f4e94"]])

export default __exports__